import { call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_SILAL_IMAGES,
  actionSetLastFetchedSilalImages,
  actionSetSilalImages,
} from './image_library_actions';
import SolrRepository, {
  SilalImagesResponse,
} from '../../data/repositories/solr_repository';

export function* sagaGetSilalImages() {
  function* getSilalImages(action: any) {
    try {
      const {
        page = 1,
        limit = 100,
        query = '*',
        sortField = 'date_created',
        sortOrder = 'desc',
        is_silal_owned,
      } = action.payload.data;

      // Use the updated method from SolrRepository
      const res: SilalImagesResponse | false = yield call(
        SolrRepository.getSilalImages,
        {
          page,
          limit,
          query,
          sortField,
          sortOrder,
          is_silal_owned,
        },
      );

      if (!res) {
        console.error('Failed to fetch Silal images.');
        if (action.payload.failure) {
          action.payload.failure(new Error('Failed to fetch Silal images.'));
        }
        return;
      }

      // Update the Redux store with the fetched images
      yield put(actionSetSilalImages(res.images));
      yield put(actionSetLastFetchedSilalImages(new Date().getTime()));

      // Invoke the success callback if provided
      if (action.payload.success) {
        action.payload.success(res);
      }
    } catch (error: any) {
      console.error('Error in sagaGetSilalImages:', error);

      // Invoke the failure callback if provided
      if (action.payload.failure) {
        action.payload.failure(error);
      }
    }
  }

  yield takeLatest(GET_SILAL_IMAGES, getSilalImages);
}
